"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var types_generated_exports = {};
__export(types_generated_exports, {
  isCompleteQualificationHistoryEvent: () => isCompleteQualificationHistoryEvent,
  isQualification: () => isQualification,
  isQualificationHistoryEvent: () => isQualificationHistoryEvent,
  isQualificationRegisterEntry: () => isQualificationRegisterEntry,
  isQualificationRegisterPrivacy: () => isQualificationRegisterPrivacy,
  isQualificationRegisterSettings: () => isQualificationRegisterSettings,
  isQualificationRegisterSharing: () => isQualificationRegisterSharing
});
module.exports = __toCommonJS(types_generated_exports);
var import_types_generated = require("../core/types.generated.js");
var import_types_generated2 = require("../permission/types.generated.js");
var import_types_generated3 = require("../user/types.generated.js");
const isQualification = (v) => {
  return typeof v === "object" && v != null && "name" in v && typeof v.name === "string" && "alias" in v && (0, import_types_generated.isQualificationAlias)(v.alias) && "id" in v && (0, import_types_generated.isQualificationId)(v.id);
};
const isCompleteQualificationHistoryEvent = (v) => {
  return typeof v === "object" && v != null && "qualificationId" in v && (0, import_types_generated.isQualificationId)(v.qualificationId) && "userId" in v && (0, import_types_generated.isUserId)(v.userId) && "timestamp" in v && (0, import_types_generated.isTimestamp)(v.timestamp) && (!("roleName" in v) || (0, import_types_generated2.isQualificationRoleName)(v.roleName) || v.roleName === null) && (!("updatedBy" in v) || (0, import_types_generated3.isUserRef)(v.updatedBy) || v.updatedBy === null) && (!("notes" in v) || typeof v.notes === "string" || v.notes === null) && "id" in v && (0, import_types_generated.isQualificationHistoryEventId)(v.id);
};
const isQualificationHistoryEvent = (v) => {
  return typeof v === "object" && v != null && "timestamp" in v && (0, import_types_generated.isTimestamp)(v.timestamp) && (!("roleName" in v) || (0, import_types_generated2.isQualificationRoleName)(v.roleName) || v.roleName === null) && (!("updatedBy" in v) || (0, import_types_generated3.isUserRef)(v.updatedBy) || v.updatedBy === null) && (!("notes" in v) || typeof v.notes === "string" || v.notes === null);
};
const isQualificationRegisterPrivacy = (v) => {
  return v === "Email" || v === "Name" || v === "ScreenName";
};
const isQualificationRegisterSharing = (v) => {
  return v === "Public" || v === "Unlisted" || v === "Private";
};
const isQualificationRegisterSettings = (v) => {
  return typeof v === "object" && v != null && "privacy" in v && isQualificationRegisterPrivacy(v.privacy) && "sharing" in v && isQualificationRegisterSharing(v.sharing);
};
const isQualificationRegisterEntry = (v) => {
  return typeof v === "object" && v != null && "id" in v && typeof v.id === "string" && "qualificationId" in v && (0, import_types_generated.isQualificationId)(v.qualificationId) && (!("userId" in v) || (0, import_types_generated.isUserId)(v.userId) || v.userId === null) && (!("firstName" in v) || typeof v.firstName === "string" || v.firstName === null) && (!("lastName" in v) || typeof v.lastName === "string" || v.lastName === null) && (!("screenName" in v) || (0, import_types_generated.isScreenName)(v.screenName) || v.screenName === null) && (!("email" in v) || (0, import_types_generated.isEmail)(v.email) || v.email === null) && "privacy" in v && isQualificationRegisterPrivacy(v.privacy) && "sharing" in v && isQualificationRegisterSharing(v.sharing) && "lastUpdate" in v && isQualificationHistoryEvent(v.lastUpdate);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isCompleteQualificationHistoryEvent,
  isQualification,
  isQualificationHistoryEvent,
  isQualificationRegisterEntry,
  isQualificationRegisterPrivacy,
  isQualificationRegisterSettings,
  isQualificationRegisterSharing
});
//# sourceMappingURL=types.generated.js.map
